export default "__VITE_ASSET__MYml852e__"